import styled from '@emotion/styled';
import { Spin as AntSpin } from 'antd';

export const SSpin = styled(AntSpin)`
  .ant-spin-dot-item {
    background-color: #000 !important;
  }
`;
